import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  title: PropTypes.string.isRequired,
}

function PlaceholderPage({ title }) {
  return (
    <div className="content-block-container">
      <header className="section-header">
        <h1>{title}</h1>
        <p>This section is coming soon.</p>
      </header>
    </div>
  )
}

PlaceholderPage.propTypes = propTypes

export default PlaceholderPage
